'use client';

import Image from 'next/image';
import { CardContent, CardHeader, CardTitle } from '../card';

interface SuccessCardProps {
  onReset: () => void;
}

export default function SuccessCard({ onReset }: SuccessCardProps) {
  return (
    <>
      <CardHeader className="p-1 rounded-xl bg-emerald-600">
        <div className="relative text-center">
          <CardTitle className="text-2xl font-bold text-white px-6 py-3">
            You’re All Set!
          </CardTitle>
        </div>
      </CardHeader>

      <CardContent className="p-6 pt-8 ">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <Image
              src="/icons/check.svg"
              alt="check icon"
              width={65}
              height={65}
              className="text-white"
            />
          </div>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Hang Tight!
          </h3>

          <p className="text-gray-600 mb-6">
            Keep your phone close — one of our team members will text or call
            you soon with personalized quotes for your window project.
          </p>
        </div>
      </CardContent>
    </>
  );
}
